<template>
  <tr :class="{
    'bg-warning': warehouseProductConfig &&
      warehouseProductConfig.warnschwelle > 0 &&
      warehouseProductConfig.warnschwelle > (warehouseProduct.stock_rotations.length ? warehouseProduct.stock_rotations[0].quantity_sum : 0)
  }">
    <td>
      <router-link :to="`/products/${warehouseProduct.id}`" slot="reference">
        {{ warehouseProduct.name }}
      </router-link>
    </td>
    <td class="text-right" v-text="warehouseProduct.stock_rotations.length ? warehouseProduct.stock_rotations[0].quantity_sum : 0"></td>
    <td class="text-right">
      <span v-if="! editMode">{{ warehouseProductConfig ? warehouseProductConfig.warnschwelle : null }}</span>
      <input v-else class="form-control quick-input" v-model="configToEdit.warnschwelle">
    </td>
    <td class="text-right">
      <span v-if="! editMode">{{ warehouseProductConfig ? warehouseProductConfig.soll_menge : null }}</span>
      <input v-else class="form-control quick-input" v-model="configToEdit.soll_menge">
    </td>
    <td class="text-right">
      <div class="td-actions">
        <template v-if="editMode">
          <button class="btn btn-success btn-link btn-xs"
            v-tooltip.top-center="'Speichern'"
            @click="saveEdit"
          >
            <i class="fas fa-check"></i>
          </button>
          <button class="btn btn-danger btn-link btn-xs"
            v-tooltip.top-center="'Cancel'"
            @click="exitEditMode"
          >
            <i class="fa fa-close"></i>
          </button>
        </template>
        <template v-else>
          <button class="btn btn-warning btn-link btn-xs"
            v-tooltip.top-center="'Bearbeiten'"
            @click="enterEditMode"
          >
            <i class="fas fa-edit"></i>
          </button>
          <button v-tooltip.top-center="'Löschen'" class="btn btn-danger btn-link btn-xs"
            @click="deleteConfig"
          >
            <i class="fa fa-close"></i>
          </button>
        </template>
      </div>
    </td>
  </tr>
</template>

<script>

export default {
  props: ['warehouseProduct'],
  data () {
    return {
      editMode: false,
      configToEdit: {
        id: null,
        soll_menge: null,
        warnschwelle: null,
        warehouse_id: this.$route.params.id
      }
    }
  },
  methods: {
    enterEditMode () {
      if (this.warehouseProductConfig) {
        this.configToEdit.id = this.warehouseProductConfig.id
        this.configToEdit.soll_menge = this.warehouseProductConfig.soll_menge
        this.configToEdit.warnschwelle = this.warehouseProductConfig.warnschwelle
      } else {
        this.configToEdit.id = null
        this.configToEdit.soll_menge = null
        this.configToEdit.warnschwelle = null
      }
      this.editMode = true
    },
    exitEditMode () {
      this.editMode = false
    },
    saveEdit () {
      let res = null
      if (this.warehouseProductConfig) {
        res = this.$http.put(`/products/${this.warehouseProduct.id}/warehouse_config/${this.warehouseProductConfig.id}`, this.configToEdit).then(({ data }) => {
          this.warehouseProductConfig.soll_menge = data.soll_menge
          this.warehouseProductConfig.warnschwelle = data.warnschwelle
        })
      } else {
        res = this.$http.post(`/products/${this.warehouseProduct.id}/warehouse_config`, this.configToEdit).then(({ data }) => {
          this.warehouseProduct.warehouse_configs.push(data)
        })
      }
      res.then(() => (this.editMode = false))
    },
    deleteConfig () {
      if (this.warehouseProductConfig && confirm('Warnschwellen & Sollmengen Konfiguration löschen?')) {
        this.$http.delete(`/products/${this.warehouseProduct.id}/warehouse_config/${this.warehouseProductConfig.id}`).then(() => {
          this.warehouseProduct.warehouse_configs.splice(0, 1)
        })
      }
    }
  },
  computed: {
    warehouseProductConfig () {
      return this.warehouseProduct.warehouse_configs.length ? this.warehouseProduct.warehouse_configs[0] : null
    }
  }
}
</script>
